/**
 * Wherever this is imported, please ensure to have the Snackbar component as well.
 * As we are sending saved message from here.
 */
import axios from 'axios'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}

export default {

    methods: {

        /**
         * @param host
         * @param username
         * @param password
         * @returns {Promise<boolean|any>}
         */
        async genericValidateFtpConnection(host, username, password) {

            let params = {
                host,
                username,
                password
            }

            try {
                const response = await axios.get('validate_ftp_connection.php', {params});

                if (response) {
                    return response.data
                }
            } catch (error) {
                // TODO: Log error
                console.log(error)
            }
            return false

        },

    }

}
